export const isBlackFridayToggleManualSet = (search: string) => {
    const params = new URLSearchParams(search)
    return params.has('black_promo')
}
